<template>
    <v-layout>
        <PrizeShop />
    </v-layout>
</template>

<script>
import PrizeShop   from '@/components/view_blocks/Prize_shop/Prize_shop_wrap.vue';
import {mapGetters} from 'vuex';

export default {
  components: {
    PrizeShop,
  },
  computed: {

  },
};
</script>
